module.exports = __webpack_public_path__ + "static/media/bannermob-2.4a127f38.jpg";